<div class="fixed inset-0 z-50 transition-opacity duration-[150ms]"
     [class.opacity-0]="!isOpen()"
     [class.pointer-events-none]="!isOpen()">

	<div class="absolute inset-0 bg-[rgba(5,5,15,0.92)] backdrop-blur-[14px] transition-opacity duration-[150ms]"
	     [class.opacity-0]="!isOpen()"
	     (click)="onBackdropClick($event)"></div>

	<div class="absolute inset-0 flex items-center justify-center"
	     style="transition: transform 0.2s ease, opacity 0.15s ease"
	     [class.opacity-0]="!isOpen()"
	     [style.transform]="!isOpen() ? 'scale(0.98)' : 'scale(1)'">
		<div class="absolute inset-0 flex items-center justify-center">
			<video #animVideo playsinline preload="auto" class="w-full h-full object-cover"></video>
		</div>
		<peps-cards-layer #cardsLayer />
	</div>

	@for (entry of ownedCards(); track entry.index) {
		<div class="absolute z-[55] flex flex-col items-center gap-2 -translate-x-1/2 pointer-events-none"
		     [style.left]="'calc(50% + ' + entry.slot.x + 'px)'"
		     [style.top]="'calc(50% + ' + (entry.slot.y + cardHeight * entry.slot.scale / 2 + 14) + 'px)'">
			<span class="text-base uppercase tracking-widest text-peps-gold font-dinpro-medium whitespace-nowrap">
				{{ 'page.booster-opening.owned' | translate: {score: entry.drawn.bestOwnedScore} }}
			</span>
			@if (destroyedIndexes().has(entry.index)) {
				<span class="text-sm uppercase tracking-widest text-white/60">{{ 'page.booster-opening.destroyed' | translate }}</span>
			} @else if (destroyRewards()[entry.drawn.card.rarity] !== undefined) {
				<button class="pointer-events-auto py-2 px-4 text-base uppercase border border-peps-gold text-peps-gold cursor-pointer hover:bg-peps-gold hover:text-white whitespace-nowrap"
				        style="transition: background-color 0.2s, color 0.2s"
				        (click)="destroyDuplicate(entry.index)"
				>{{ 'page.booster-opening.destroy' | translate: {coins: destroyRewards()[entry.drawn.card.rarity]} }}</button>
			}
		</div>
	}

	<div class="fixed left-1/2 -translate-x-1/2 bottom-10 z-[60] flex flex-col sm:flex-row gap-3 items-center"
	     style="transition: opacity 0.4s"
	     [class.opacity-0]="!isDone()"
	     [class.pointer-events-none]="!isDone()">
		<button class="py-2 px-4 uppercase bg-peps-gold text-white text-lg cursor-pointer flex items-center justify-center"
		        style="transition: background-color 0.2s, color 0.2s"
		        (click)="close()"
		>{{ 'page.booster-opening.close' | translate }}</button>
		@if (hasNextBooster()) {
			<button class="py-2 px-4 uppercase border border-peps-gold text-peps-gold text-lg cursor-pointer flex items-center justify-center hover:bg-peps-gold hover:text-white"
			        style="transition: background-color 0.2s, color 0.2s"
			        (click)="next()"
			>{{ 'page.booster-opening.open-next' | translate }}</button>
		}
	</div>
</div>
